const parseJsonSafely = async (response) => {
  try {
    const text = await response.text();
    if (!text) return { StatusCode: response.status, Message: response.statusText };
    return JSON.parse(text);
  } catch {
    return { StatusCode: 500, Message: "Invalid response from server" };
  }
};

export const Fetchdata = async (dataToSend) => {
  if (!dataToSend.FetchURL) return { StatusCode: 400, Message: "No URL provided" }

  try {
    if (dataToSend.Type === "POST") {
      const response = await fetch(dataToSend.FetchURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });
      return await parseJsonSafely(response);
    } else {
      const response = await fetch(dataToSend.FetchURL);
      return await parseJsonSafely(response);
    }
  } catch {
    return { StatusCode: 500, Message: "Network error" };
  }
};

